import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	starred: {
		id: 'atlassian-navigation.filters.menu.favorite-content.starred',
		defaultMessage: 'Starred',
		description: 'The STARRED title.',
	},
});
